import { Component, signal, ChangeDetectionStrategy } from '@angular/core';

import { MdwAside } from '@spaces-ui/meadow/components/aside';
import { MdwButton } from '@spaces-ui/meadow/components/button';

import { Sample } from '../../components';

@Component({
  selector: 'app-app-elements',
  imports: [Sample, MdwAside, MdwButton],
  templateUrl: './app-elements.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app-elements.scss',
})
export class AppElements {
  public isCollapsed = signal<boolean>(false);
  public isFloating = signal<boolean>(false);
  public isSecondaryCollapsed = signal<boolean>(false);
  public isSecondaryFloating = signal<boolean>(false);
}
